<template>
	<h1>Themes de question pour fiche d'exercice</h1>
	<table>
		<tr>
			<th></th>
			<th>Nom</th>
			<th>Modifier</th>
			<th>Supprimer</th>
		</tr>
		<tr
			v-for="(questionTheme, index) in this.$store.state
				.exerciseQuestionThemes"
			:key="index"
		>
			<td>{{ index }}</td>
			<td>{{ questionTheme.name }}</td>
			<td>
				<router-link
					:to="{
						name: 'SuperAdminEditExerciseSheetQuestionTheme',
						params: { id: questionTheme.id },
					}"
					>Modifier</router-link
				>
			</td>
			<td>
				<button @click="deleteQuestionTheme(questionTheme.id)">
					supprimer
				</button>
			</td>
		</tr>
	</table>
</template>

<script>
import { authenticatedApiFetch } from '../../utils/utils'

export default {
	methods: {
		deleteQuestionTheme(e) {
			if (confirm("Do you really want to delete?")) {
				authenticatedApiFetch(`/exercise-question-themes/${e}/`, { method: 'DELETE' })
					.then(() => {

						this.$store.dispatch('getExerciseSheetThemes')
					})
			}
		},
	},
}
</script>

<style>
</style>
